<!-- TEMPLATE -->
<template>
  <div>
    <div class="dean-tab-bar">
      <div class="row">
        <div
          :key="item.title"
          :class="tabClass(item.active)"
          v-for="item in data"
          @click="deanTabBarClick(item)"
        >
          <dean-icon
            class="dean-icon"
            :glyph="item.icon"
            height="20"
          ></dean-icon>
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanSidemenu extends Vue {
  //PROPS
  @Prop() data!: Array<any>;0

  // METHODS
  deanTabBarClick(item: string) {
    console.log(item);
    this.$emit('dean-tab-bar-click', item);
  }

  tabClass(active: boolean) {
    let value = 'column-flex';
    if (active) value += ` active`;
    return value
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-tab-bar {
  display: block;
  width: 100%;
  padding: 10px;

  .row {
    background: var(--color-light-shade-2, $color-light-shade-2);
    @include border-radius(10px 10px 0px 0px);

    .column-flex {
      display: flex;
      align-content: center;
      justify-content: center;
      height: 40px;
      text-align: center;
      cursor: pointer;
      @include transition(all ease 0.8s);
      background: var(--color-light-shade-2, $color-light-shade-2);
      &:focus,
      &:hover,
      &:active {
        background: var(--color-light, $color-light);
      }
      
      &:first-of-type {
        border-right: 1px solid var(--color-dark-shade-4, $color-dark-shade-4);
        @include border-radius(10px 0px 0px 0px);
      }
      &:nth-of-type(n) {
        border-right: 1px solid var(--color-light, $color-light);
      }
      &:last-of-type {
        border-right: 0;
        @include border-radius(0px 10px 0px 0px);
      }
      .dean-icon {
        display: inline-flex;
        align-self: center;
        height: 20px;
        margin: 0;
        fill: var(--color-dark-shade-4, $color-dark-shade-4);
      }
      p {
        display: inline-flex;
        align-self: center;
      }
    }

    .active {
      background: white;
      //@include border-radius(10px 10px 0px 0px);
      &:focus,
      &:hover,
      &:active {
        background: white;
      }
      
      border-top: 1px solid var(--color-light-shade-2, $color-light-shade-2);
      &:first-of-type {
        border-left: 1px solid var(--color-light-shade-2, $color-light-shade-2);
      }
      &:last-of-type {
        border-right: 1px solid var(--color-light-shade-2, $color-light-shade-2);
        @include border-radius(0px 10px 0px 0px);
      }
    }
  }
}
</style>
